import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import { FormEvent } from "react";
import { toast } from "react-toastify";

export default function ModalCriarPasta({ show, handleClose, handleCriarPasta }:iProps) {
    function handleSubmit(event: FormEvent<HTMLFormElement>) {
            event.preventDefault()
            event.stopPropagation()
        
            removeAllErrorMsg()
    
            const form:any = event.target
            let formValidado = true
    
            let dados = {
                nome: form.nome.value,
            }
    
            if (dados.nome === "") {
                toast.error('Informe o novo nome!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                form.nome.nextElementSibling.style.display = "block"
                formValidado = false
            }
    
            console.log(dados)
            if (!formValidado) {
                return
            }
    
            handleCriarPasta(dados.nome)
        }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title><b>Criar Pasta</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formCriarPasta`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Nome:</Form.Label>
                                <Form.Control type="text" name="nome" id="nome" required />
                                <Form.Control.Feedback type="invalid">
                                    Informe o novo nome!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br/>
                    <Button type="submit" variant="success">Salvar</Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    handleClose: any
    handleCriarPasta: any
}